module.exports = __webpack_public_path__ + "static/img/2.4bd3cca6.png";